import {z} from 'zod';

import {
  BaseVoidResponseSchema,
  BasketTooltipSchema,
  MinMaxQuantitySchema,
  PriceWithAndWithoutVatSchema,
} from '@dms/api/shared';

export const TransferOrderBasketItemSchema = z.object({
  id: z.string(),
  warehouse_id: z.string(),
  itemEditingAllowed: z.boolean(),
  priceType: z.string(),
  requestType: z.string(),
  name: z.string(),
  manufacturerNumber: z.string(),
  manufacturerId: z.string(),
  quantity: z.number(),
  unit: z.string().nullish(),
  dispensingUnit: z.number(),
  quantityEditingAllowed: z.boolean(),
  unitPrice: PriceWithAndWithoutVatSchema,
  discount: PriceWithAndWithoutVatSchema.extend({
    rate: z.number(),
  }),
  totalPrice: PriceWithAndWithoutVatSchema,
  minMaxQuantity: MinMaxQuantitySchema,
  tooltip: z.array(BasketTooltipSchema),
});
export type TransferOrderBasketItem = z.infer<typeof TransferOrderBasketItemSchema>;

/**
 * GET
 */
export const GetTransferOrderBasketRequestSchema = z.object({
  transferOrderId: z.string(),
});
export type GetTransferOrderBasketRequest = z.infer<typeof GetTransferOrderBasketRequestSchema>;

export const GetTransferOrderBasketResponseSchema = z.object({
  orderTransferBasketItem: z.array(TransferOrderBasketItemSchema),
  orderTransferBasketTotalPrice: PriceWithAndWithoutVatSchema,
});
export type GetTransferOrderBasketResponse = z.infer<typeof GetTransferOrderBasketResponseSchema>;

/**
 * POST
 */
export const CheckoutTransferOrderBasketRequestSchema = z.object({
  transferOrderId: z.string(),
});
export type CheckoutTransferOrderBasketRequest = z.infer<
  typeof CheckoutTransferOrderBasketRequestSchema
>;

export const CheckoutTransferOrderBasketResponseSchema = BaseVoidResponseSchema;
export type CheckoutTransferOrderBasketResponse = z.infer<
  typeof CheckoutTransferOrderBasketResponseSchema
>;

export const DiscardTransferOrderBasketRequestSchema = z.object({
  transferOrderId: z.string(),
});
export type DiscardTransferOrderBasketRequest = z.infer<
  typeof DiscardTransferOrderBasketRequestSchema
>;

export const DiscardTransferOrderBasketResponseSchema = BaseVoidResponseSchema;
export type DiscardTransferOrderBasketResponse = z.infer<
  typeof DiscardTransferOrderBasketResponseSchema
>;
/**
 * PATCH
 */

/**
 * DELETE
 */
